<!--  -->
<template>
  <div class="popupCoupon" v-if="show">
    <img
      class="title"
      src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/live/coupon-title.png"
      alt=""
    />
    <div class="box" v-if="popupCouponInfo">
      <p>
        <b>{{ popupCouponInfo.nickName }}</b
        ><span>领取了</span>
      </p>
      <h2>{{ popupCouponInfo.couponName }}</h2>
    </div>
    <img
      class="btn"
      src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/live/coupon-btn.png"
      @click="openCoupon"
    />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },
  props: {
    popupCouponInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {
    show(data) {
      if (data) {
        setTimeout(() => {
          this.show = false;
        }, 5000);
      }
    },
  },
  methods: {
    openCoupon(){
      this.$emit('openCoupon')
    }
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.popupCoupon {
  position: fixed;
  right: 8px;
  bottom: 150px;
  z-index: 110;
  display: flex;
  flex-direction: row;
  width: 496px;
  height: 98px;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/live/coupon-bg.png')
    no-repeat;
  background-size: 100%;
  .title {
    position: relative;
    top: -20px;
    width: 129px;
    height: 118px;
  }
  .box {
    padding: 12px 0 0 14px;
    p {
      display: flex;
      align-items: center;
      width: 278px;
      height: 40px;
      margin-bottom: 8px;
      padding-left: 14px;
      color: #ffe399;
      font-weight: 500;
      font-size: 22px;
      line-height: 40px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/live/coupon-bg1.png')
        no-repeat;
      background-size: 100%;
      b {
        display: inline-block;
        max-width: 180px;
        margin-right: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span {
        color: #fff;
        font-weight: 500;
        font-size: 22px;
      }
    }
    h2 {
      width: 250px;
      overflow: hidden;
      color: #583d30;
      font-weight: 500;
      font-size: 22px;
      line-height: 32px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .btn {
    width: 86px;
    height: 86px;
  }
}
</style>
